export const marketLinkPrefix = slug => (slug ? `/${slug}` : '')
